import { faIndustry } from '@fortawesome/pro-solid-svg-icons'
import type { ReactElement } from 'react'
import { HeaderIcon, HeaderTitle, PageHeader } from '~/components/Layout/Page'

export const Header = (): ReactElement => {
  return (
    <PageHeader>
      <HeaderTitle>
        <HeaderIcon icon={faIndustry} />
        Entreprises
      </HeaderTitle>
    </PageHeader>
  )
}
